import { NavLink as RouterNavLink, NavLinkProps } from "react-router-dom"
import { NavItem } from "~styled/app"

interface CustomNavLinkProps extends Omit<NavLinkProps, "className"> {
  children: React.ReactNode
  label?: string
}

const NavLink = ({ to, children, label, ...props }: CustomNavLinkProps) => {
  const getClassName = ({ isActive }: { isActive: boolean }) =>
    isActive ? "active" : ""

  const isExactMatch = to === "/app" || to === "/app/"

  return (
    <NavItem data-tooltip={label}>
      <RouterNavLink
        to={to}
        className={getClassName}
        end={isExactMatch}
        {...props}
      >
        {children}
      </RouterNavLink>
    </NavItem>
  )
}

export default NavLink
